import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import { Touch } from 'vuetify/lib/directives'
// import 'vuetify/src/styles/main.sass'
// import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  directives: {
    Touch
  }
})

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    themes: {
      light: {
        primary: colors.pink.darken1,
        secondary: colors.pink.darken3,
        accent: '#cb9ca1'
      }
    }
  }
})
